var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,11.0308118 L20,12.9691882 L12.9693159,12.968475 L11.0306841,12.968475 L4,12.9691882 L4,11.0308118 L11.0312323,11.0303913 L12.9687677,11.0303913 L20,11.0308118 Z M20,17.0004205 L20,18.9387968 L12.9693159,18.9380836 L11.0306841,18.9380836 L4,18.9387968 L4,17.0004205 L11.0312323,17 L12.9687677,17 L20,17.0004205 Z M20,5.00042049 L20,6.93879682 L12.9693159,6.93808362 L11.0306841,6.93808362 L4,6.93879682 L4,5.00042049 L11.0312323,5 L12.9687677,5 L20,5.00042049 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.62c4623ea1601e1cb72fc0dda1f16175.svg";
export { ForwardRef as ReactComponent };